import { Autocomplete, TextField } from '@mui/material'
import React from 'react'

const InputSelectDropdown = (props) => {
    const { id, options, inputprops, cbSelect, cbInput } = props
    const { label = "" } = inputprops

    // const selectedValues2 = React.useMemo(
    //     () => spareList.filter((item) => item.selected),
    //     [allValues],
    // );
    return (
        <div className=''>
            <div className="d-flex ">
                <Autocomplete
                    value={inputprops.value}
                    onChange={(event, newValue) => {
                        if (typeof cbSelect === "function") {
                            cbSelect(event, id, newValue);
                        }
                    }}
                    // inputValue={'inp'}
                    onInputChange={(event, newInputValue) => {
                        if (typeof cbInput === "function") {
                            cbInput(event, id, newInputValue);
                        }
                    }}
                    id={`controllable-states-demo-${id}`}
                    options={options}
                    sx={{ width: props.width?props.width:300 }}
                    renderInput={(params) => <TextField {...params} label={label} id={`controllable-states-demo-input-${id}`} />}
                />
            </div>
        </div>
    )
}

export default InputSelectDropdown